import React, { useEffect, useState } from 'react';
import { SignDialog } from '../components/dialog/SignDialog';
import { HistoryTable } from '../components/history/HistoryTable';
import { HomeWrapper } from '../components/utils/HomeWrapper';
import { PageTitle } from '../components/utils/PageTitle';
import Tooltip from '@mui/material/Tooltip';
import { Button } from "@mui/material";
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from '../api/CommProvider';
import AutoDeleteIcon from '@mui/icons-material/AutoDelete';
import { useTranslation } from "react-i18next";

export function History() {
    /* Dialog */
    const { t } = useTranslation("global")
    
    const [sign, setSign] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [prevDialogPosition, setPrevDialogPosition] = useState(undefined);

    const [dialogElements, setDialogElements] = useState([]);
    const { token_id, currentUser, json_data_USER, set_json_data_USER, genEntryByLemma } = useDataProvider();
    const { comm_getHistory, comm_removeHistory } = useCommProvider();

    useEffect(() => {

        async function update_UserHistory(){
            const user_history = await comm_getHistory(token_id, currentUser)
            const csession = json_data_USER.session;
            csession['arr_history'] = user_history;
            set_json_data_USER({ ...json_data_USER, session: csession });

        }
        update_UserHistory()
    }, []);

    async function handleResetHistory(){
        const user_history = await comm_removeHistory(token_id, currentUser)
        const csession = json_data_USER.session;
        csession['arr_history'] = [];
        set_json_data_USER({ ...json_data_USER, session: csession });

    }

    async function showDialog(row_id) {
        setDialogElements(genEntryByLemma(row_id));
        setOpenDialog(true);
    }

    return (
        <HomeWrapper>
            <PageTitle title='HISTORIAL'/>
            <HistoryTable showDialog={showDialog}>  
                <Tooltip title={t("sTooltip.clear_history")} placement='bottom' arrow>
                    <Button className="sig_Main_IconButton" onClick={handleResetHistory}>
                        <AutoDeleteIcon className="sig_Home_ChangeOnDarkMode"/>
                    </Button>
                </Tooltip>
            </HistoryTable>
            <SignDialog dialogElements={dialogElements} setDialogElements={setDialogElements} loading={false} openDialog={openDialog} setOpenDialog={setOpenDialog} setPrevDialogPosition={setPrevDialogPosition}/>
        </HomeWrapper>
    )
}